module.exports = __webpack_public_path__ + "img/Richpanel_logo_colored.7f362a83.svg";